import { localStorageKeys } from '../../apiCommons'

const defaultCostCenter = { id: '', value: '', label: 'Todos' }

const setCompanyData = (companyData) => {
  const costCenters =
    companyData.sCentroCosto?.length > 0
      ? [...companyData.sCentroCosto, defaultCostCenter]
      : [defaultCostCenter]
  localStorage.setItem(
    localStorageKeys.companyData,
    JSON.stringify({
      ...companyData,
      sCentroCosto: costCenters,
    }),
  )
}
const setUserData = (data) => {
  localStorage.setItem('currentUser', JSON.stringify(data))
}

const getCompanyData = () => {
  const localData = JSON.parse(
    localStorage.getItem(localStorageKeys.companyData),
  )
  if (localData) {
    return localData
  }
  return {}
}

const getUserData = () => {
  const localData = JSON.parse(
    localStorage.getItem(localStorageKeys.currentUser),
  )
  if (localData) {
    return {
      ...localData,
      user: localData?.oEmpresa?.[0],
      sEmpresa: localData?.oEmpresa?.[0].sEmpresa,
    }
  }
  return {}
}

const setRegions = (regions) => {
  const formattedRegions = JSON.stringify(regions)
  localStorage.setItem(localStorageKeys.regions, formattedRegions)
}
const getRegions = () => {
  const localData = localStorage.getItem(localStorageKeys.regions)
  return JSON.parse(localData)
}

const eraseData = () => {
  localStorage.clear()
}

export default {
  setCompanyData,
  getCompanyData,
  getUserData,
  eraseData,
  getRegions,
  setRegions,
  setUserData,
}
